module.exports = __webpack_public_path__ + "static/Saffron-57c67a062a0cbe2f1c396f3fad6127ab.png";